// extracted by mini-css-extract-plugin
export default {"placeView":"PlacesViewSection_placeView__VUzZa","list":"PlacesViewSection_list__eB1s9","item":"PlacesViewSection_item__VgG0V"};